import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const PostPreviewModal = ({ post, isOpen, onClose }) => {
  if (!isOpen || !post) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={onClose}>
      <div 
        className="bg-card rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e?.stopPropagation()}
      >
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between z-10">
          <h2 className="text-xl font-semibold text-foreground">Post Details</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-colors"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="w-full h-80 rounded-lg overflow-hidden bg-muted">
                <Image
                  src={post?.image}
                  alt={post?.imageAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="flex items-center gap-2">
                <span className="px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full">
                  {post?.type}
                </span>
                <span className="text-sm text-muted-foreground">{post?.date}</span>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <h3 className="text-sm font-medium text-muted-foreground mb-2">Post Content</h3>
                <p className="text-foreground">{post?.content}</p>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-muted/50 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <Icon name="Eye" size={16} className="text-primary" />
                    <span className="text-sm text-muted-foreground">Reach</span>
                  </div>
                  <p className="text-2xl font-bold text-foreground">{post?.reach?.toLocaleString()}</p>
                </div>

                <div className="bg-muted/50 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <Icon name="Heart" size={16} className="text-error" />
                    <span className="text-sm text-muted-foreground">Reactions</span>
                  </div>
                  <p className="text-2xl font-bold text-foreground">{post?.reactions?.toLocaleString()}</p>
                </div>

                <div className="bg-muted/50 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <Icon name="MessageCircle" size={16} className="text-primary" />
                    <span className="text-sm text-muted-foreground">Comments</span>
                  </div>
                  <p className="text-2xl font-bold text-foreground">{post?.comments?.toLocaleString()}</p>
                </div>

                <div className="bg-muted/50 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <Icon name="Share2" size={16} className="text-success" />
                    <span className="text-sm text-muted-foreground">Shares</span>
                  </div>
                  <p className="text-2xl font-bold text-foreground">{post?.shares?.toLocaleString()}</p>
                </div>
              </div>

              <div className="bg-primary/10 rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-foreground">Engagement Rate</span>
                  <span className="text-2xl font-bold text-primary">{post?.engagementRate}%</span>
                </div>
                <div className="w-full h-2 bg-muted rounded-full mt-3 overflow-hidden">
                  <div 
                    className="h-full bg-primary rounded-full transition-all duration-300"
                    style={{ width: `${post?.engagementRate}%` }}
                  />
                </div>
              </div>

              <div className="flex gap-2">
                <Button variant="default" iconName="ExternalLink" className="flex-1">
                  View on Facebook
                </Button>
                <Button variant="outline" iconName="Download">
                  Export
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostPreviewModal;